import ArBaseButton from 'src/components/ArBaseButton/ArBaseButton'
import ArFormInput from './ArFormInput'
import ArMonoTag from '../typography/ArMonoTag'
import Axios from 'axios'
import { FreeCameraOptions } from 'mapbox-gl'
import PropTypes from 'prop-types'
import React from 'react'
import SimpleReactValidator from 'simple-react-validator'
import generateJSX from 'src/utils/generateJSX'
import handleClickAction from 'src/utils/handleClickAction'
// import generateJSX from 'src/utils/generateJSX'
import { media } from 'src/styles/styled-components'
import styled from 'styled-components'

const StyledForm = styled.form`
  color: ${ ({ theme }) => theme.colors.dark };
  ${ ({ mobileFormStyles }) => mobileFormStyles }
  ${ media.tablet`${ ({ tabletFormStyles }) => tabletFormStyles }` }
  ${ media.desktop`${ ({ desktopFormStyles }) => desktopFormStyles }` }
  margin-top: 40px;
`

const StyledInput = styled(ArFormInput)`
  margin-bottom: 20px;

  ${ media.tablet`
    margin-bottom: 25px;
  ` }
`

const StyledButtonSend = styled(ArBaseButton)`
  max-width: none;
  width: 100%;

  ${ media.tablet`
    max-width: 250px;
  ` }
`

const StyledFooterWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  width: 100%;

  ${ media.tablet`
    flex-direction: row;
  ` }
`

const StyledFormResponse = styled.div`
  color: ${ p => p.theme.colors[p.error ? 'red' : 'black'] };
  font-family: ${ p => p.theme.font.secondary };
  font-size: 1.2rem;
  margin-top: 20px;
  width: 100%;

  span {
    font-weight: ${ p => p.theme.fontWeight.secondary.Bold };
    line-height: 1.33;
    margin-bottom: 10px;
  }

  ${ media.tablet`
    margin-top: 0;
    width: auto;
    margin-left: 23px;
  ` }
`

const StyledFooterText = styled.div`
  margin-top: 15px;
  span {
    line-height: 1.83;
    color: #2E323C;
  }
  a {
    color: ${ p => p.theme.colors.red };
  }
`

class ArDynamicForm extends React.Component {
  constructor (props) {
    super(props)
    this.validator = new SimpleReactValidator()
    this.state = {
      formData: {},
      formState: {
        sending: false,
        success: false,
        errors: [],
      },

    }
    this.populateFormData()
  }

  static propTypes = {
    form: PropTypes.object,
  }

  handleSubmit (e) {
    e.preventDefault()

    const isNotValid = Object.keys(this.state.formData).find(key => !this.state.formData[key].valid)

    if (isNotValid) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.setState({
        formState: {
          sending: false,
          success: false,
          errors: ['You haven’t filled in the form correctly.'],
        },
      })
      return
    }

    this.setState({
      formState: {
        sending: true,
        success: false,
        errors: [],
      },
    })

    Axios
      .post(this.props.form.request.url, this.getFormDataPayload())
      .then(() => {
        this.setState({
          formState: {
            sending: false,
            success: true,
            errors: [],
          },
        })
      })
      .catch(err => {
        const responseMsg = err.statusText || 'You haven’t filled in the form correctly.'
        handleClickAction({
          action: 'scrollToElement',
          id: '#beta-community-form',
          offsetTop: -100,
        })
        this.setState({
          formState: {
            sending: true,
            success: false,
            errors: [...this.state.formState.errors, responseMsg],
          },
        })
      })
  }

  getFormDataPayload () {
    const payload = {}
    Object.keys(this.state.formData).forEach(key => {
      payload[key] = this.state.formData[key].value
    })
    return payload
  }

  populateFormData () {
    this.props.form.fields.forEach(field => {
      this.state.formData[field.name] = {
        valid: true,
        value: '',
      }
    })
  }

  onChange ({ name, value, valid }) {
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: { value, valid },
      },
      formState: {
        sending: false,
        success: false,
        errors: [],
      },
    })
  }

  render () {
    const { form, footerText, ...rest } = this.props
    return (
      <StyledForm {...rest}>
        {form.fields.map(({ tag, type, name, label, placeholder, required, rules }, index) =>
          <StyledInput
            dark={true}
            key={index}
            tag={tag}
            type={type}
            label={label}
            placeholder={placeholder}
            required={required}
            name={name}
            onChange={this.onChange.bind(this)}
            rules={rules}
          />
        )}

        {form.buttonTitle && <StyledFooterWrapper>
          <StyledButtonSend
            type="submit"
            onClick={this.handleSubmit.bind(this)}
            label={this.state.formState.success && form.buttonSuccessTitle ? form.buttonSuccessTitle : form.buttonTitle}
            variant={ this.state.formState.success ? 'green' : 'violet'}
            disabled={this.state.formState.success}
            hideIcon={this.state.formState.success && form.hideButtonIconAfterSuccess}
          />
          {this.state.formState.errors.length > 0 && (
            <StyledFormResponse error={true}>
              <span>{form.errorMessageTitle || 'Oops!'}</span>
              {form.errorMessage && <p>Please check all fields and try again!</p>}
              {!form.errorMessage && this.state.formState.errors.map((err, i) => (<p key={i}>{err}</p>))}
            </StyledFormResponse>
          )}
          {this.state.formState.success && (
            <StyledFormResponse>
              <span>{form.buttonTitleSuccess || 'Thanks for signing up!'}</span>
              <p>{form.successDescription || 'You’ll receive an email shortly'}</p>
            </StyledFormResponse>
          )}
        </StyledFooterWrapper>}

        {footerText && <StyledFooterText>
          <ArMonoTag>
            {generateJSX(footerText)}
          </ArMonoTag>
        </StyledFooterText>
        }

      </StyledForm>
    )
  }
}

export default ArDynamicForm
